import {useTranslation} from 'react-i18next';
import {Helper, SeriesTypeBadge} from '@tickchak/react-share/live';
import Chevron from '../../../../assets/icons/Chevron';
import {TEticketSubscriptionPlanType} from '../../../../redux/eTicket/eTicket.type';
import * as css from './MemberInfoSheet.css';

interface MemberSeriesInfoBarProps {
    planType?: TEticketSubscriptionPlanType;
    totalCredits: number;
}

/* The bar at the top of the details sheet: series type, how many tickets it redeems, and a helper */
function MemberSeriesInfoBar({planType, totalCredits}: MemberSeriesInfoBarProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.infoBar data-cy="member-series-info-bar">
            {planType && <SeriesTypeBadge planType={planType} label={t(`seriesTypes.${planType}`)} data-cy="member-series-type" />}
            {totalCredits > 0 && (
                <>
                    <css.arrow aria-hidden><Chevron fill="currentColor" /></css.arrow>
                    <css.infoText>{t('creditsForSelection', {count: totalCredits})}</css.infoText>
                </>
            )}
            {planType && (
                <Helper
                    size="small"
                    content={t(`seriesTypesInfo.${planType}`)}
                    ariaLabel={t('seriesTypeHelp')}
                    data-cy="member-series-help"
                />
            )}
        </css.infoBar>
    );
}

export default MemberSeriesInfoBar;
